import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideGift, lucideImage } from '@ng-icons/lucide';
import { isHexColor } from '../../../../../utils/color.utils';

/**
 * How the brand looks where it is used: the storefront header, the voucher app's
 * button and a voucher PDF. Sketches fed with the live (unsaved) values, so a
 * change shows before saving. Not the real pages.
 */
@Component({
  selector: 'app-brand-preview',
  imports: [NgIcon],
  providers: [provideIcons({ lucideGift, lucideImage })],
  templateUrl: './brand-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandPreviewComponent {
  readonly name = input('');
  readonly logoUrl = input<string | null>(null);
  readonly bannerUrl = input<string | null>(null);
  readonly primaryColor = input<string | null | undefined>(null);
  readonly textColor = input<string | null | undefined>(null);

  /** While a colour is being typed, keep showing a valid one. */
  protected readonly primary = computed(() => {
    const color = this.primaryColor();
    return isHexColor(color) ? color : '#4b5ae4';
  });
  protected readonly onPrimary = computed(() => {
    const color = this.textColor();
    return isHexColor(color) ? color : '#FFFFFF';
  });
  protected readonly displayName = computed(() => this.name() || 'Dein Geschäft');
}
